import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import HeroSpotlight from '../components/HeroSpotlight';
import VendorShowcase from '../components/VendorShowcase';
import CollabTeaser from '../components/CollabTeaser';
import SubscriptionTiers from '../components/SubscriptionTiers';
import Footer from '../components/Footer';
import PreviewCarousel from '../components/PreviewCarousel';
import VendorMap from '../components/VendorMap';

function Home() {
  return (
    <div className="woodexpo-app">
      <Header />

      {/* Hero Parallax — Swiss alpine forest */}
      <section className="parallax parallax-hero" id="showcase">
        <VendorMap />
        <div className="parallax-content">
          <h2 className="hero-title">Timber Summit</h2>
          <p className="hero-subtitle">Trade in craftsmanship. Deal in knowledge.</p>
          <Link to="/artisans"><button className="btn-primary hero-cta">Enter the Summit →</button></Link>
        </div>
        <PreviewCarousel />
      </section>

      <HeroSpotlight />

      {/* Mid parallax break — Deep forest */}
      <section className="parallax parallax-mid">
        <div className="parallax-content">
          <p className="parallax-quote">"The intersection of marketplace and mastery."</p>
        </div>
      </section>

      <VendorShowcase />

      {/* Lower parallax break — Mountain woodland */}
      <section className="parallax parallax-lower">
        <div className="parallax-content">
          <p className="parallax-quote">"Built by hand. Sold by the maker."</p>
        </div>
      </section>

      <CollabTeaser />
      <SubscriptionTiers />
      <Footer />
    </div>
  );
}

export default Home;
